import {httpsCallable} from 'firebase/functions';
import {functions} from './firebase';

interface RephraseData {
  descriptionText: string;
  language: string;
  shouldTranslate: boolean;
}

// Initialize the cloud function helper
// This takes the firebase functions instance and the name of the cloud function
const completionFunction = httpsCallable<RephraseData, string>(
  functions,
  'gptCompletion'
);

/**
 * Asynchronously retrieves AI completion based on the provided description text.
 *
 * (In the context of AI, "completion" refers to the process by which an artificial
 * intelligence system generates text, code, or other outputs that complete a given
 * prompt, task, or query based on learned patterns, data, and context.
 *
 * This process is fundamental to AI models designed for natural language
 * understanding and generation, such as chatbots, predictive text systems,
 * and coding assistants.)
 */
const getCompletion = async (params: RephraseData): Promise<string> =>
  (await completionFunction(params)).data;

export default getCompletion;
